export default __webpack_public_path__ + "static/media/cancerDiagnostic.965a5ded.png";